import { useQuery, useQueryClient, useMutation } from 'react-query';

import { APIResponse, defaultMutationFn } from 'api';
import { Notification } from 'models';

const NOTIFICATIONS_PATH = '/notifications';

export function useNotifications() {
  return useQuery<APIResponse<Notification[]>>(NOTIFICATIONS_PATH);
}

export function useDeleteAllNotifications() {
  const queryClient = useQueryClient();

  return useMutation(() => defaultMutationFn(NOTIFICATIONS_PATH, 'DELETE'), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(NOTIFICATIONS_PATH);
    },
  });
}

export function useDeleteNotification() {
  const queryClient = useQueryClient();
  return useMutation(
    (notificationId: string) => {
      const path = `${NOTIFICATIONS_PATH}/${notificationId}`;
      return defaultMutationFn(path, `DELETE`);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(NOTIFICATIONS_PATH);
      },
    }
  );
}

export function useUpdateNotificationReadStatus() {
  const queryClient = useQueryClient();

  return useMutation(
    (notificationId: string) => {
      const path = `${NOTIFICATIONS_PATH}/${notificationId}?read=true`;
      return defaultMutationFn(path, `PUT`);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(NOTIFICATIONS_PATH);
      },
    }
  );
}
